






































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import request from '@/utils/request';
import moment from 'moment';
import AMSBreadcrumb from '../../components/AMSBreadcrumb.vue';
import Utils from '@/utils/utils';
import AMSProductImg from '../../components/AMSProductImg.vue';
import AMSTooltip from '@/components/AMSTooltip.vue';

@Component({
  components: {
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-productimg': AMSProductImg,
    'ams-tooltip': AMSTooltip
  }
})
export default class ProductDetails extends Vue {
  breadItems = [
    {
      text: '商品管理',
      disabled: false,
      href: '/productManage'
    },
    {
      text: '商品列表',
      disabled: false,
      href: '/productManage'
    },
    {
      text: '商品详情',
      disabled: true
    }
  ];
  productId: string | (string | null)[] = '';
  account = 0;
  imgList = [];
  recordList = [];
  detailsList = {
    status: ''
  };
  productLinks = [];

  get canEdit() {
    return this.detailsList.status === 'StopSale' && Utils.isPermission('ProductManager.ProductsList.CreateOrEdit');
  }

  goBack() {
    this.$router.go(-1);
  }
  modify(record: any, type: string) {
    this.$router.push({
      path: '/productManage/create',
      query: { id: record.id }
    });
  }
  formatDate(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  leftimage(index: number) {
    let first = this.imgList.splice(index, 1)[0];
    this.imgList.unshift(first);
  }
  rightimage() {
    this.account++;
    if (this.account < this.imgList.length) {
      let next = this.imgList.splice(this.account, 1)[0];
      this.imgList.unshift(next);
    } else {
      let first = this.imgList.splice(-1, 1)[0];
      this.imgList.unshift(first);
    }
  }
  formatPrice(num: number) {
    return Utils.formatCurrencyPrice(num);
  }
  created() {
    this.productId = this.$route.query.id;
    if (this.productId) {
      this.getDetails(this.productId);
      this.getoperationReacord(this.productId);
    }
  }
  // 详情
  getDetails(id: string | (string | null)[]) {
    request
      .get(`/api/Product/${id}`, {})
      .then((data: any) => {
        this.detailsList = data;
        this.imgList = data.pictures;
        this.productLinks = data.productLinks;
      })
      .catch((err: any) => {});
  }
  ImageUrl(data: any): string {
    return `${process.env.VUE_APP_FILE_URL}/${data}`;
  }
  // 操作记录
  getoperationReacord(id: string | (string | null)[]) {
    request
      .get(`/api/Product/${id}/logs`, {})
      .then((data: any) => {
        this.recordList = data.items;
      })
      .catch((err: any) => {});
  }
}
